import axios from "./axios-auth";

const getClientBlogs = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getallclientblogs",
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("error getClientBlogs" + err);
      });
  });

const getAuthorizedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getauthorizedclients",
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while fetching authorized clients api");
      });
  });

const saveClientBlogs = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/saveclientblogs",
      data: payload,
      method: "POST",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("error while saving clients" + err);
      });
  });

export { getClientBlogs, getAuthorizedClients, saveClientBlogs };
